module.exports = __webpack_public_path__ + "static/assets/e21225ab4b675bc61eed30cfb510c288.svg";